import { Column, ModelBase } from 'loca-boot-core'

/**
 * 心愿地址数据概览
 */
export class WishPowerSummaryModel extends ModelBase {
  /**
   * 心愿地址数量
   */
  @Column({ name: 'wish_address_num' })
  public wishAddressNum!: string

  /**
   * 统计更新时间
   */
  @Column({ name: 'statistic_update_time' })
  public statisticUpdateTime!: string
}
